export const scrollToSection = (sectionId) => {
  const element = document.getElementById(sectionId);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
};

export const handleFormSubmit = (formData) => {
  // Handle form submission logic here
  console.log('Form submitted:', formData);
  // You can integrate with email services like EmailJS here
};

export const validateEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
};